import { StreamEntityType } from 'types/enums';
import { SlideTypes } from '../types';

export const getStreamEntityType = (type?: SlideTypes) => {
    let streamEntityType;

    switch (type) {
        case SlideTypes.Repacks:
            streamEntityType = StreamEntityType.Repacks;
            break;
        case SlideTypes.Custom:
            streamEntityType = StreamEntityType.Custom;
            break;
        case SlideTypes.Packs:
            streamEntityType = StreamEntityType.Packs;
            break;
        case SlideTypes.Labels:
            streamEntityType = StreamEntityType.Packs;
            break;
        default:
            streamEntityType = StreamEntityType.Packs;
            break;
    }

    return streamEntityType;
};
